import React from "react";
import Layout from "../../components/Layout";
import HomeSectionFAQ from "../Home/HomeSectionFAQ";

const LOCATION_URL = "https://share.google/nRoU3arkLFDmFkvND";

const Faq = () => (
  <Layout
    title="ISO Certification FAQs | MBA Solutions"
    description="Find answers about ISO 9001, ISO 14001, ISO 27001 certification, audit timelines, training, and how MBA Solutions can help your business."
    keywords="ISO certification FAQ, ISO 9001 questions, certification process, MBA Solutions FAQ"
    canonical="https://mbasolutions.co/faq"
  >
    <div className="home-page bg-[#F2F2F2] overflow-x-hidden min-h-[60vh]">
      <HomeSectionFAQ locationUrl={LOCATION_URL} />
    </div>
  </Layout>
);

export default Faq;
